import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	timeline: {
		overflowY: "auto",
		overflowX: "hidden",
		maxHeight: "calc(60vh - 200px)",
		[theme.breakpoints.down("sm")]: {
			maxHeight: "calc(100vh - 200px)",
		},
	},
	EventHistoryContainer: {
		overflowY: "auto",
		overflowX: "hidden",
		maxHeight: "calc(60vh - 200px)",
		[theme.breakpoints.down("sm")]: {
			maxHeight: "calc(100vh - 160px)",
		},
	},
	arrivalDate: {
		fontSize: "0.835rem",
	},
	EventHistoryRowContiner: {
		padding: theme.spacing(1, 2),
	},
	eventAndStatusHistoryContainer: {
		marginBottom: theme.spacing(2),
		marginTop: theme.spacing(0),
	},
	tab: {
		backgroundColor: theme.palette.background.paper,
	},
	noResultFound: {
		padding: theme.spacing(2),
	},
	timelineItem: {
		margin: theme.spacing(1, 0),
		padding: theme.spacing(0, 1),
	},
	timelineContent: {
		paddingLeft: theme.spacing(1),
		paddingBottom: theme.spacing(0.5),
	},
	qty: {
		paddingLeft: theme.spacing(0.75),
	},
}));
